import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getCategories(params?: any) {
  return AuthHttpClient
    .get('/stores/seagm/category', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function addCategory(data: any) {
  return AuthHttpClient
    .post('/stores/seagm/category', data)
    .then(handleResponse)
    .catch(handleError)
}

export function updateCategory(data: any, categoryId: string | number) {
  return AuthHttpClient
    .patch(`/stores/seagm/category/${categoryId}`, data)
    .then(handleResponse)
    .catch(handleError)
}

export function deleteCategory(categoryId: string | number) {
  return AuthHttpClient
    .delete(`/stores/seagm/category/${categoryId}`)
    .then(handleResponse)
    .catch(handleError)
}
